const schema = localStorage.getItem("schema")
export const basicFormData = () => ({
  "inputData": {
    "intake_no": "",
    "material_id":"",
    "customer_id":"",
    "issue_descriptions": "",
    "received_date": "",
    "received_by": "",
    "status": "",
    "is_active": true
  }
});

export const createPageData = () => {
  const payload = {
    modelName: "material_intakes",
    schema:schema,
    "include": [
      { "model": "material_masters", "as": "material" },
      { "model": "client_masters", "as": "customer" },
      { "model": "user_masters", "as": "received_by_user" },
      { "model": "user_masters", "as": "inspected_by_user" }
    ]
  };

  const navigatePage = { back: "/material-intakes-list" };

  const headerName = "Material Intakes";

  const validationType = "MaterialIntakesCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const payload = {
    modelName: "material_intakes",
    schema:schema,
    "include": [
      { "model": "material_masters", "as": "material" },
      { "model": "client_masters", "as": "customer" },
      { "model": "user_masters", "as": "received_by_user" },
      { "model": "user_masters", "as": "inspected_by_user" }
    ]
  };

  const columnData = [
    { label: "Sr.no", value: "index" },
    { label: "Intake Number", value: "intake_no" },
    { label: "Material Name", value: "material.name" },
    { label: "Customer Name", value: "customer.client_name" },
    { label: "Is Repairable", value: "is_repairable" },
    { label: "Inspected By", value: "inspected_by_user.first_name" },
    { label: "Received By", value: "received_by_user.first_name" },
    { label: "Received Date", value: "received_date" },
    { label: "Status", value: "status" },
    { label: "Is Active", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/material-intakes-create",
    edit: "/material-intakes-create",
    view: "/material-intakes-view",
  };

  const searchfields = [
    "intake_no",
    "material.name",
    "customer.client_name",
    "is_repairable",
    "inspected_by_user.first_name",
    "received_by_user.first_name",
    "status",
  ];

  const headerName = "Material Intakes";
  const endpoint = "/getRecords";
  const exportFileName = "MaterialIntakesData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "material_intakes",
  schema: schema,
  "include": [
    { "model": "material_masters", "as": "material" },
    { "model": "client_masters", "as": "customer" },
    { "model": "user_masters", "as": "received_by_user" },
    { "model": "user_masters", "as": "inspected_by_user" }
  ],
  pagination: { page: 1, pageSize: 10000 },
};
